export const LEARNING_CARDS_ROUTES = {
    BASE: '/learning-cards',
    GROUPS: '/learning-cards/groups',
    GROUP_DETAIL: '/learning-cards/groups/:groupId',
    TEST: '/learning-cards/groups/:groupId/test',
};

export const GROUP_VISIBILITY = {
    PRIVATE: 'PRIVATE',
    PUBLIC: 'PUBLIC',
    UNLISTED: 'UNLISTED'
};

export const GROUP_VISIBILITY_LABELS = {
    [GROUP_VISIBILITY.PRIVATE]: 'Private (Only you can see)',
    [GROUP_VISIBILITY.PUBLIC]: 'Public (Anyone can see and use)',
    [GROUP_VISIBILITY.UNLISTED]: 'Unlisted (Only accessible with direct link)'
};

export const CARD_SIDE_TYPES = {
    CARD_SIDE_NULL: 'CARD_SIDE_NULL',
    CARD_SIDE_JAPANESE: 'CARD_SIDE_JAPANESE'
};

export const CARD_SIDE_TYPE_LABELS = {
    [CARD_SIDE_TYPES.CARD_SIDE_NULL]: 'Standard',
    [CARD_SIDE_TYPES.CARD_SIDE_JAPANESE]: 'Japanese'
};

export const DEFAULT_CARD_SIDE_TYPES = [
    CARD_SIDE_TYPES.CARD_SIDE_NULL,
    CARD_SIDE_TYPES.CARD_SIDE_NULL
];

export const CARD_DISPLAY_MODE = {
    SIDE_1_AS_FRONT: 'SIDE_1_AS_FRONT',
    SIDE_2_AS_FRONT: 'SIDE_2_AS_FRONT'
};

export const CARD_DISPLAY_MODE_LABELS = {
    [CARD_DISPLAY_MODE.SIDE_1_AS_FRONT]: 'Side 1 as Front',
    [CARD_DISPLAY_MODE.SIDE_2_AS_FRONT]: 'Side 2 as Front'
};

export const CARD_MARKS = {
    MARK_NULL: 0,
    MARK_A: 1,
    MARK_B: 2,
    MARK_C: 3,
    MARK_D: 4,
    MARK_E: 5
};

export const CARD_MARK_LABELS = {
    'MARK_NULL': 'New',
    'MARK_A': 'A',
    'MARK_B': 'B',
    'MARK_C': 'C',
    'MARK_D': 'D',
    'MARK_E': 'E',
    0: 'New',
    1: 'A',
    2: 'B',
    3: 'C',
    4: 'D',
    5: 'E'
};

export const CARD_MARK_COLORS = {
    'MARK_NULL': 'bg-secondary',
    'MARK_A': 'bg-success',
    'MARK_B': 'bg-info',
    'MARK_C': 'bg-warning',
    'MARK_D': 'bg-danger',
    'MARK_E': 'bg-dark',
    0: 'bg-secondary',
    1: 'bg-success',
    2: 'bg-info',
    3: 'bg-warning',
    4: 'bg-danger',
    5: 'bg-dark'
};